const ACCOUNT_UPDATED = (state, account) => {
  state.account = account
}

export default {
  ACCOUNT_UPDATED,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/account/mutations.js